// profile activate account 
export const UPDATE_PROFILE_ACTIVITATE = "UPDATE_PROFILE_ACTIVITATE"
export const UPDATE_PROFILE_ACTIVITATE_SUCCESS = "UPDATE_PROFILE_ACTIVITATE_SUCCESS"
export const UPDATE_PROFILE_ACTIVITATE_ERROR = "UPDATE_PROFILE_ACTIVITATE_ERROR"

// profile deactiviate account
export const UPDATE_PROFILE_DEACTIVATE = "UPDATE_PROFILE_DEACTIVATE"
export const UPDATE_PROFILE_DEACTIVATE_SUCCESS = "UPDATE_PROFILE_DEACTIVATE_SUCCESS"
export const UPDATE_PROFILE_DEACTIVATE_ERROR = "UPDATE_PROFILE_DEACTIVATE_ERROR"
